module.exports = __webpack_public_path__ + "img/FreeTraining-1.4db79928.png";